import React, { Fragment, useContext, useEffect, useState } from "react";
import propTypes from "prop-types";
import { Button, Image } from "react-bootstrap";
import localization from "assets/localization/localization";
import Images from "assets/images/imageData";
import Layout from "components/sales/layout/layout";
import GSTDetails from "components/sales/formSection/GSTDetails/gstDetails";
// import ParkingRules from "components/sales/formSection/parkingRules/parkingRules";
import MaterialHardware from "components/sales/formSection/editPostSaleApt/materialHardwareSection/materialHardware";
import ShippedTo from "components/sales/formSection/shippedTo/shippedTo";
import BilledTo from "components/sales/formSection/billedTo/billedTo";
import ClientDetails from "components/sales/formSection/clientDetails/clientDetails";
import OtherDetailsApt from "components/sales/formSection/otherDetails/otherDetailsApt";
import GateDetails from "components/sales/formSection/gateDetails/gateDetailsApt";
// import DummyAdd from "components/sales/formSection/gateDetails/dummyAdd";
import Commercial from "components/sales/formSection/commercial/commercial";
import Installation from 'components/sales/formSection/commercial/installation';
import Milestone from 'components/sales/formSection/mileStone/mileStone';
import ModalPop from "components/sales/modal/modal";
import { Link } from "react-router-dom";
import { BaseUrl } from "contexts/baseUrl/baseUrl";
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import AgreementContract from "components/sales/formSection/agreementContract/agreementContract";
import Checkbox from "components/sales/Input/checkbox/checkbox";
import Tags from 'components/sales/formSection/materialHardware/tags';
import AdvancePayment from 'components/sales/formSection/materialHardware/advancePayment';
import Increament from 'components/sales/formSection/materialHardware/increament';
import InvoiceModule from 'components/sales/formSection/materialHardware/invoiceModule';
import AddPoc from "../../../../components/sales/formSection/addPoc/addPoc";
import SaleType from "components/sales/formSection/saleType/saleType";
import B2BRevenue from "../../postSales/B2BRevenue";
import ContractServices from "../../postSales/ContractServices";

const EditAptContract = (props) => {
  const {
    history,
    contractApartment,
    contractAptData,
    pincodeData,
    locationPinCode,
    postSalesEditApartmentLead,
    documentUploadUrl,
    documentUrlData,
    match,
    getMaterial,
    getMateriaById,
    getBrandById,
    getBrand,
    imageUploadUrl,
    videoUploadUrl,
    supplyNameFun,
    splNameData,
    shipTolocationPinCode,
    shipToPincodeData,
    clientBillingPocData,
    clientBillingAddress,
    salesTypeDetails,
    getContractRevenue,
    contractRevenueDetails=[],
    getContractService,
    contractCatService=[]
  } = props;
  const { params } = match;
//   console.log(params);
  const postDataInputs = {
    commercial: null,
    gSTDetails: null,
    shippedTo: null,
    // billedTo: null,
    // clientData: null,
    otherDetails: null,
    gateDetails: null,
    // category: [],
    materialHardwares: "No",
    tags:[],
    installation: null,
    InvoiceModuleData:null,
    pocData: null,
    revenue_nature: null,
    revenue_type: null,
    invoice_type:'Post',
  };
//   const {prerequisiteData} = contractAptData;
  const [disabled, setDisabled] = useState(true);
  const { baseUrl } = useContext(BaseUrl);
  const [isFiled, setIsFiled] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [isClicked, setIsClicked] = useState(false);
  const [showAgreementDetails, setShowAgreementDetails] = useState(false);
  const [agreementLength, setAgreementLength] = useState(null);
  const [isGateDetailsChanged, setIsGateDetailsChanged] = useState(false);
  //   const [prerequisiteData, setPrerequisiteData] = useState(null);
  // const [sameAsBillTo, setSameAsBillTo] = useState(null);
  const [variableServices, setVariableServices] = useState([{id:'', amount:'', qty:'', men_days:0, start_day:'', end_day:''}])
  const [fixedServices, setFixedServices] = useState([{id:'', amount:'', qty:'', men_days:0}])

  const [postApartmentInputs, setPostApartmentData] = useState(postDataInputs);

  const handleCommercial = (val) => {
    setPostApartmentData({ ...postApartmentInputs, commercial: val });
    if (val?.totalContract) {
      setShowAgreementDetails(true);
      setAgreementLength(val?.totalContract);
    }
  };
  const handleGstDetails = (val) => {
    setPostApartmentData({ ...postApartmentInputs, gSTDetails: val });
  };

  const handleGateDtl = (val) => {
    setPostApartmentData({ ...postApartmentInputs, gateDetails: val });
    setIsGateDetailsChanged(true);
  };
  const handleMileStone = (val) => {
    setPostApartmentData({ ...postApartmentInputs, milestone: val });
  };
  // const handleBillTo = (val) => {
  //   setPostApartmentData({ ...postApartmentInputs, billedTo: val });
  // };
  const handleShippedTo = (val) => {
    setPostApartmentData({ ...postApartmentInputs, shippedTo: val });
  };
  // const handleClientData = (val) => {
  //   setPostApartmentData({ ...postApartmentInputs, clientData: val });
  // };
  const handlePocData = (val) => {
    setPostApartmentData({ ...postApartmentInputs, pocData: val });
  };
  const handleOtherDetails = (val) => {
    setPostApartmentData({ ...postApartmentInputs, otherDetails: val });
  };
  const handleGatesData = (val) => {
    setPostApartmentData({ ...postApartmentInputs, categoryInventory: val });
  };
  const handleProductData = (val) => {
    setPostApartmentData({ ...postApartmentInputs, productInventory: val });
  };
  const handleMaterialhardware = (val) => {
    setPostApartmentData({ ...postApartmentInputs, materialHardwares: val });
  };
  const handleagreementDtls = (val) => {
    setPostApartmentData({ ...postApartmentInputs, agreementDtls: val });
  };
  const handleTags = (val) => {
    setPostApartmentData({ ...postApartmentInputs, tagsData: val });
  };
  const handleInstallation = (val) => {
    setPostApartmentData({ ...postApartmentInputs, installation: val });
  };
  const handlePayment = (val) => {
    setPostApartmentData({ ...postApartmentInputs, advPayment: val });
  };
  const handleIncreament = (val) => {
    setPostApartmentData({ ...postApartmentInputs, increamentData: val });
  };  
  const handleInvoiceAmt = (val) => {
    setPostApartmentData({ ...postApartmentInputs, InvoiceModuleData: val });
  }; 
  const handlesalesTypeDtls = (val) => {
    setPostApartmentData({ ...postApartmentInputs, salesTypeDetails: val });
  };

  const handleModalHide = () => {
    history.push(`${baseUrl}/postSalesListing`);
    setIsModal(false);
  };

  /* useEffect(() => {
    if (
        contractAptData?.prerequisiteData !== undefined &&
        contractAptData?.prerequisiteData !== null
    ) {
      const {
        prerequisiteData
      } = contractAptData;
      setPrerequisiteData(prerequisiteData);
    }
  }, [contractAptData]); */

  const handleSubmit = (id) => {
    setIsClicked(true);
    const {
      commercial,
      gSTDetails,
      gateDetails,
      // billedTo,
      shippedTo,
      // clientData,
      // otherDetails,
      categoryInventory,
      productInventory,
      materialHardwares,
      agreementDtls,
      advPayment,
      installation,
      increamentData,
      tagsData,
      InvoiceModuleData,
      milestone,
      salesTypeDetails,
      pocData,
      revenue_nature,
      revenue_type,
      invoice_type
    } = postApartmentInputs;
    // console.log(postApartmentInputs); return false;

    if (
        commercial != null &&
        gSTDetails != null &&
        shippedTo != null &&
        agreementDtls != null &&
        // clientData != null &&
        gateDetails != null &&
        // otherDetails != null &&
        materialHardwares != null &&
        salesTypeDetails !== null
        && pocData !== null
    ) {
      setIsFiled(false);

      if(salesTypeDetails == null) {
        toast.error('Please fill Type of sales details.');
        return false;
      }
      if(salesTypeDetails != null) {
          if(salesTypeDetails.salesType !== 'Direct Sales') {
            if(salesTypeDetails.channelPartner == '' || salesTypeDetails.channelPartner == null) {
              toast.error('Please fill channel partner under section type of sales.');
              return false;
            } else if(salesTypeDetails.channelPartner === 'Others') {
              if(salesTypeDetails.channelPartnerValue == null || salesTypeDetails.channelPartnerValue == '') {
                toast.error('Please fill channel partner name under section type of sales.');
                return false;
              }
            }
          }
      }

      // if(clientData != null && clientData.billing_address !== undefined){
        var fObj = {
          ...commercial,
          ...installation,
          ...gSTDetails,
          // ...parkingRules,
          // ...billedTo,
          ...shippedTo,
          // ...otherDetails,
          ...agreementDtls,
          // clientData: clientData,
          gateDetails: gateDetails,
          leadStatus:contractAptData.leadStatus,
          comm_id:contractAptData.comm_id,
          materialHardwares: { ...materialHardwares },
          ...salesTypeDetails,
          pocData: pocData,
          // ...clientData.billing_address
        }; 
      // }else{
      //   var fObj = {
      //     ...commercial,
      //     ...installation,
      //     ...gSTDetails,
      //     // ...parkingRules,
      //     // ...billedTo,
      //     ...shippedTo,
      //     ...otherDetails,
      //     ...agreementDtls,
      //     clientData: clientData,
      //     gateDetails: gateDetails,
      //     leadStatus:contractAptData.leadStatus,
      //     comm_id:contractAptData.comm_id,
      //     materialHardwares: { ...materialHardwares },
      //     // ...clientData.billing_address
      //   }; 
      // }

      // if (categoryInventory !== null && categoryInventory !== undefined) {
      //   fObj.categoryInventory = [
      //     ...categoryInventory,
      //     ...productInventory?.productData,
      //   ];
      // } else {
      //   fObj.categoryInventory = [];
      // }

      if (categoryInventory !== null && categoryInventory !== undefined && productInventory !== null && productInventory !== undefined) {
        fObj.categoryInventory = [
          ...categoryInventory,
          ...productInventory?.productData,
        ];
      } else if (categoryInventory !== null && categoryInventory !== undefined) {
        fObj.categoryInventory = [
          ...categoryInventory,
        ];
      } else if (productInventory !== null && productInventory !== undefined) {
        fObj.categoryInventory = [
          ...productInventory?.productData,
        ];
      } else {
        fObj.categoryInventory = [];
      }


      if (tagsData !== null && tagsData !== undefined) {
        fObj.tags = [
          ...tagsData?.tagData,
        ];
      } else {
        fObj.tags = [];
      }
      if (advPayment !== null && advPayment !== undefined) {
        fObj.payment = [
          ...advPayment?.advData,
        ];
      } else {
        fObj.payment = [];
      }
      if (increamentData !== null && increamentData !== undefined) {
        if (increamentData?.inc?.increament_type) {
          if (increamentData?.inc?.increament_type == 'flat' || increamentData?.inc?.increament_type == 'percentage') {
            if (increamentData?.inc?.duration == undefined || increamentData?.inc?.increament_amount == undefined) {
              return false;
            }
          }
          fObj.increament = [
            increamentData
          ];
        } else {
          fObj.increament = [];
        }
      } else {
        fObj.increament = [];
      }
      if (milestone !== null && milestone != undefined) {
        let totalAmt = parseInt(fObj.totalAmount);
        let calculatedAmt = 0;
        if (!isNaN(totalAmt)) {
          if (totalAmt > 0) {
            for (let i = 0; i < postApartmentInputs.milestone?.milestone_data.length; i++) {
              if (postApartmentInputs.milestone.milestone_data[i].amt) {
                calculatedAmt += parseInt(postApartmentInputs.milestone.milestone_data[i].amt);
              }
            }
            for (let i = 0; i < postApartmentInputs.milestone?.date_invoices_data.length; i++) {
              if (postApartmentInputs.milestone.date_invoices_data[i].amt) {
                calculatedAmt += parseInt(postApartmentInputs.milestone.date_invoices_data[i].amt);
              }
            }
            for (let i = 0; i < postApartmentInputs.milestone?.retention.length; i++) {
              if (postApartmentInputs.milestone.retention[i].amt) {
                calculatedAmt += parseInt(postApartmentInputs.milestone.retention[i].amt);
              }
            }
            console.log("calculatedAmt "+calculatedAmt);
            console.log("totalAmt "+totalAmt);
            
            if(calculatedAmt == 0){
              toast.error('Please Fill atleast one milestone');
              return;
            }else if (calculatedAmt > totalAmt) {
              toast.error('Milestone total amount is greater then capex amount!');
              setIsClicked(false);
              setIsFiled(true);
              return;
            }else if (calculatedAmt != totalAmt) {
              toast.error('Milestone total amount should be equal to capex amount!');
              setIsClicked(false);
              setIsFiled(true);
              return;
            }
            else {
              fObj.milestone=milestone;
            }
          }
        }
      }

      fObj['revenue_nature'] = revenue_nature
      fObj['revenue_type'] = revenue_type
      fObj['invoice_type'] = invoice_type
      if(contractAptData?.commercialData !== undefined && contractAptData?.commercialData?.revenue_nature === 'Valet'){
        fObj['variable_services'] = variableServices
        fObj['fixed_services'] = fixedServices
      } else{
        fObj['invoice_type'] = 'Pre'
        fObj['revenue_type'] = 'Fixed'
        fObj['revenue_nature'] = 'Self'
      }

      if(InvoiceModuleData !== null && InvoiceModuleData != undefined){
        let subsAmt = Number(contractAptData?.commercialData?.subscription_amount);
        let invoiceAmt = InvoiceModuleData?.invoiceAmt;
        // console.log(subsAmt);
        // console.log(invoiceAmt);
        const initialValue = 0;
        const sumWithInitial = invoiceAmt.reduce(
          (previousValue, currentValue) => previousValue + currentValue,
          initialValue
        );
        // console.log(sumWithInitial);
        if(subsAmt === sumWithInitial ){
          fObj.InvoiceModuleData=InvoiceModuleData;
        }else{
          toast.error('Total amount of invoice module is not equal to the total subscription amount!');
          setIsClicked(false);
          setIsFiled(true);
          return;
        }
       

      }
      // console.log(fObj); return false;
      (async () => {
        const res = await postSalesEditApartmentLead({ ...fObj, leadId: parseInt(params.manageId), comm_id: parseInt(params.id)});
        if (res) {
          setIsModal(true);
        }
      })();
      
    } else {
      // console.log(commercial);
      // console.log(gateDetails);
      // console.log(agreementDtls);
      setIsClicked(false);
      setIsFiled(true);
      const active = document.querySelector('.activeAnkInput');
      // console.log(active);
      if(active){
        active.focus();
      }else{
        alert('Please Upload missed documents or enter valid data!!')
      }
    }
  };

  useEffect(() => {
    (async () =>
        {
          await contractApartment(params)
          await getContractRevenue()
          await getContractService('VALET')
        }
    )();
    setTimeout(() => {
      setDisabled(false);
    }, 1000);
  }, [contractApartment]);

  // console.log(postApartmentData.leadStatus);

  const handleButtons = () => {
    return (
      <Fragment>
        <Button className="btn btn-transparent hidden">{localization.save}</Button>
        <Button onClick={() => handleSubmit(params.lead_id)} disabled={disabled}>
          {localization.submitDtl} <Image fluid src={Images?.ArrowRight} />
        </Button>
      </Fragment>
    );
  };
  function refreshPage() {
    window.location.reload(false);
  }

  const handleRevenueDetails = (key, value) => {
    postApartmentInputs[key] = value
    setPostApartmentData(postApartmentInputs);
  }

  const handleVariableService = (index, key, val) => {
    let list = [...variableServices]
    let isAlreadyExist = false
    if(list.length > 1 && key === 'id'){
      variableServices.map((vali, i) => {
        if(parseInt(vali?.id) === parseInt(val)){
          isAlreadyExist = true
        }
      })
    }

    if(isAlreadyExist){
      setTimeout(() => {
        list.splice(list.length-1, 1)
        setVariableServices(list)
        toast.warning("Service already selected.")
      }, 1000)
      return false
    }

    list[index][key] = val
    setVariableServices(list)
  }

  const handleFixedService = (index, key, val) => {
    let list = [...fixedServices]
    let isAlreadyExist = false
    if(list.length > 1 && key === 'id'){
      fixedServices.map((vali, i) => {
        if(parseInt(vali?.id) === parseInt(val)){
          isAlreadyExist = true
        }
      })
    }

    if(isAlreadyExist){
      setTimeout(() => {
        list.splice(list.length-1, 1)
        setFixedServices(list)
        toast.warning("Service already selected.")
      }, 1000)
      return false
    }

    list[index][key] = val
    setFixedServices(list)
  }

  useEffect(() => {
    if(contractAptData?.valet_contract_variable_service !== undefined && Object.keys(contractAptData?.valet_contract_variable_service).length > 0){
      setVariableServices(contractAptData?.valet_contract_variable_service)
    }

    if(contractAptData?.valet_contract_fixed_service !== undefined && Object.keys(contractAptData?.valet_contract_fixed_service).length > 0){
      setFixedServices(contractAptData?.valet_contract_fixed_service)
    }
  }, [contractAptData])

  return (
    <Layout
      history={history}
      Buttons={handleButtons}
      isGoback
      className={isFiled ? "requiredFileds" : ""}
      title={localization.editContract}
    >
    { (contractAptData !== undefined || contractAptData !== null) && (
      <>
        <B2BRevenue
            handleValue={handleRevenueDetails}
            RevenueData={contractRevenueDetails}
            commercialData={contractAptData.commercialData}
            isEditable={true}
        />
        <Commercial
            is_fastag={1}
            data={contractAptData}
            handleValue={handleCommercial}
            documentUploadUrl={documentUploadUrl}
            documentUrlData={documentUrlData}
            supplyNameFun={supplyNameFun}
            splNameData={splNameData}
            prefilledData={contractAptData.postsale_data}
            edit={1}
        />
        <AgreementContract
           isApartment = {1}
          handleValue={handleagreementDtls}
          documentUploadUrl={documentUploadUrl}
          agreementLength={agreementLength}
          showDetails={showAgreementDetails}
          isEditContract={true}
          prefilledData={contractAptData.postsale_data}
        />
        <SaleType
          isApartment={1}
          handleValue={handlesalesTypeDtls}
          documentUploadUrl={documentUploadUrl}
          agreementLength={agreementLength}
          showDetails={true}
          isEditContract={true}
          prefilledData={contractAptData.postsale_data}
        />
        <GSTDetails
            handleValue={handleGstDetails}
            documentUploadUrl={documentUploadUrl}
            documentUrlData={documentUrlData}
            prefilledData={contractAptData.postsale_data}
        />
      
      <ShippedTo
        handleValue={handleShippedTo}
        locationPinCode={shipTolocationPinCode}
        pincodeData={shipToPincodeData}
        documentUploadUrl={documentUploadUrl}
        documentUrlData={documentUrlData}
        leadData={contractAptData.lead_name}
        prefilledData={contractAptData.postsale_data}
        clientBrd={contractAptData?.commercialData?.client_brd}
        // sameAsBillTo={sameAsBillTo}
      />
      {/* <ClientDetails
        handleValue={handleClientData}
        locationPinCode={locationPinCode}
        pincodeData={pincodeData}
        data={contractAptData}
        clientBillingAddress={clientBillingAddress}
        clientBillingPocData={clientBillingPocData}
        prefilledData={contractAptData.postsale_data}
      /> */}
      {contractAptData !== undefined && contractAptData !== null && (
        <AddPoc
          handleValue={handlePocData}
          prefilledData={contractAptData}
        />
      )}
      {contractAptData?.commercialData !== undefined && contractAptData?.commercialData?.revenue_nature !== 'Valet' &&
        <MaterialHardware
            handleValue={handleMaterialhardware}
            data={contractAptData}
            handleGatesData={handleGatesData}
            handleProductData={handleProductData}
            getMaterial={getMaterial}
            getMateriaById={getMateriaById}
            getBrandById={getBrandById}
            getBrand={getBrand}
            prefilledData={contractAptData.postsale_data}
            editProduct={true}
        />
      }
        {contractAptData?.commercialData !== undefined && contractAptData?.commercialData?.revenue_nature === 'Valet' &&
            <ContractServices
                serviceDetails={contractCatService}
                setVariableServices={setVariableServices}
                variableServices={variableServices}
                handleVariableService={handleVariableService}
                handleFixedService={handleFixedService}
                handleValue={handleRevenueDetails}
                setFixedServices={setFixedServices}
                fixedServices={fixedServices}
                commercialData={contractAptData?.commercialData}
            />
        }
      {contractAptData?.commercialData !== undefined && contractAptData?.commercialData?.revenue_nature !== 'Valet' &&
        <Tags
          handleValue={handleTags}
          data={contractAptData}
          prefilledData={contractAptData.postsale_data}
        />
      }
      <GateDetails
        handleValue={handleGateDtl}
        data={contractAptData}
        imageUploadUrl={imageUploadUrl}
        videoUploadUrl={videoUploadUrl}
        duplicate={false}
        prefilledData={contractAptData.postsale_data}
      />
       {contractAptData.commercialData?.commercial_type_id === 7 &&  (
        <InvoiceModule
          handleValue={handleInvoiceAmt}
          data={contractAptData} 
          prefilledData={contractAptData.postsale_data}
          invoiceAmtData = {contractAptData.postsale_data}
          isdisable={true}
        />
      )}
      {contractAptData.commercialData?.commercial_type_id === 5 && (
          <Milestone
            handleValue={handleMileStone}
            totalAmount={postApartmentInputs.commercialData}
            gateData={postApartmentInputs?.gateDetails}
            gateDetailsChanged = {setIsGateDetailsChanged} 
            isGateDetailsChanged = {isGateDetailsChanged} 
            prefilledData={contractAptData.postsale_data}
          />
      )}

      {contractAptData?.commercialData !== undefined && contractAptData?.commercialData?.revenue_nature !== 'Valet' &&
        <Installation
        isApartment = {1}
          handleValue={handleInstallation}
          prefilledData={contractAptData.postsale_data}
        />
      }

      {contractAptData?.commercialData !== undefined && contractAptData?.commercialData?.revenue_nature !== 'Valet' &&
        <Increament
          handleValue={handleIncreament}
          data={contractAptData}
          imageUploadUrl={imageUploadUrl}
          prefilledData={contractAptData.postsale_data}
        />
      }

<AdvancePayment
        handleValue={handlePayment}
        data={contractAptData}
        imageUploadUrl={imageUploadUrl}
        prefilledData={contractAptData.postsale_data}
      />

      {/* <OtherDetailsApt
        isApartment
        handleValue={handleOtherDetails}
        data={contractAptData}
        documentUploadUrl={documentUploadUrl}
        documentUrlData={documentUrlData}
        imageUploadUrl={imageUploadUrl}
        videoUploadUrl={videoUploadUrl}
      /> */}
      
      <ModalPop
        title={localization.conf}
        show={isModal}
        handleModalHide={handleModalHide}
        keyboard
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{localization.leadSuccess}</h5>
          <Link
            to={`${baseUrl}/postSalesListing`}
            className="btn btn-primary mb-4"
          >
            {localization.postSales} <img src={Images?.ArrowRight} alt="" />
          </Link>
          {/* <Link
            to={`${baseUrl}/postSalesListing`}
            className="btn btn-transparent"
          >
            {localization.createAnother}
            <img src={Images?.arrowRightBlue} alt="" />
          </Link> */}
        </div>
      </ModalPop>
      </>
    )}
    </Layout>
  );
};

EditAptContract.propTypes = {
  history: propTypes.any,
};

export default EditAptContract;
